import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';

import FacebookShareButton from 'react-share/lib/FacebookShareButton'
import GooglePlusShareButton from 'react-share/lib/GooglePlusShareButton'
import TwitterShareButton from 'react-share/lib/TwitterShareButton'
import EmailShareButton from 'react-share/lib/EmailShareButton'

import FacebookIcon from 'react-share/lib/FacebookIcon'
import TwitterIcon from 'react-share/lib/TwitterIcon'
import GooglePlusIcon from 'react-share/lib/GooglePlusIcon'
import EmailIcon from 'react-share/lib/EmailIcon'

import CircularProgress from '@material-ui/core/CircularProgress';
import { WID, getWord } from '../../../constants/Language';
import { Word } from '../../../containers';
import { useEffect } from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { SettingsContext } from '../../../Parts/Settings';
import clipboard from 'clipboard'

const styles = {
  share : {
    verticalAlign: 'top',
    display: 'inline-block',
    margin: '5px',
    textAlign: 'center',
    cursor: 'pointer',
  },
  circularProgress: {
    textAlign: 'center',
  },
  dialogContent: {
    textAlign: 'center',
  },
  shortURLCopy: {
    paddingTop: '30px',
    textAlign: 'center'
  },
}

const ShareDialog = withStyles(styles)((props) => {
  const { classes, open, url, shortURL, handleClose, handleEnter, handleEntering, handleExited } = props

  const [isInitialized, setIsInitialized] = useState(false)

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  useEffect(() => {
    if (!isInitialized) {
      var cb = new clipboard('.copy-button');
      cb.on('success', (e) =>{
        e.clearSelection();
        props.notify(getWord(WID.SHARE_DIALOG.NOTIFY.MESSAGE_SUCCESS_COPY_THE_SHORT_URL, language))
        });
        cb.on('error', (e) => {
          props.notify(getWord(WID.SHARE_DIALOG.NOTIFY.MESSAGE_FAILED_COPY_THE_SHORT_URL, language))
      })
      setIsInitialized(true)
    }
  }, [isInitialized])

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        onEnter={handleEnter}
        onExited={handleExited}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle><Word wid={WID.SHARE_DIALOG.DIALOG_TITLE}/></DialogTitle>
        {url === '' && (
          <div className={classes.circularProgress}>
            <CircularProgress className={classes.progress} />
          </div>
        )}
        {url !== '' && (
          <React.Fragment>
            <DialogContent className={classes.dialogContent}>
              <div style={styles.share}>
                <FacebookShareButton url={url} hashtags={['RenjuPortal']}>
                  <FacebookIcon size={42} round/>
                </FacebookShareButton>
              </div>
              <div style={styles.share}>
                <TwitterShareButton url={url} hashtags={['RenjuPortal']}>
                  <TwitterIcon size={42} round/>
                </TwitterShareButton>
              </div>
              <div style={styles.share}>
                <GooglePlusShareButton url={url}>
                  <GooglePlusIcon size={42} round/>
                </GooglePlusShareButton>
              </div>
              <div style={styles.share}>
                <EmailShareButton url={url}>
                  <EmailIcon size={42} round/>
                </EmailShareButton>
              </div>
            </DialogContent>
            <Divider/>
            <DialogContent className={classes.shortURLCopy}>
              <TextField
                label={<Word wid={WID.SHARE_DIALOG.SHORT_URL}/>}
                id="short-url"
                value={url}
              />
              {(clipboard !== undefined && clipboard.isSupported()) && (
                <Button
                  variant="contained"
                  style={{margin: '10px'}}
                  disabled={url === ''}
                  color="primary"
                  autoFocus
                  className={'copy-button'}
                  data-clipboard-target="#short-url"
                >
                  Copy
                </Button>
              )}
            </DialogContent>
          </React.Fragment>
        )}
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
})

export default ShareDialog


// WEBPACK FOOTER //
// ./src/components/Common/RenjuBoardCard/ShareDialog.js